module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('category-form', {
    attrs: {
      "create": true
    },
    on: {
      "saved": _vm.editCategory
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d4dacb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/categories/CategoryCreate.vue
// module id = 570
// module chunks = 0